import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as Buddies from 'actions/Buddies';

export function* onGetApprovedBuddiesRequest({ params, cb }) {
	try {
		const { size=20, page=0, studentId=null, userType=null } = params;
		const rs = yield axios.get(`/api/student/${studentId || 'current'}/getApprovedBuddies?size=${size}&page=${page}`);

		yield put(Buddies.onGetApprovedBuddiesSuccess({data: rs.data, studentId: studentId, userType: userType }));
		cb && cb(null, rs.data);
	} catch (e) {
		yield put(Buddies.onGetApprovedBuddiesFailure());
		cb && cb(e);
	}
}